import { render } from "./AvisoLegalCheck.vue?vue&type=template&id=391bd46a&scoped=true"
import script from "./AvisoLegalCheck.vue?vue&type=script&lang=js"
export * from "./AvisoLegalCheck.vue?vue&type=script&lang=js"

import "./AvisoLegalCheck.vue?vue&type=style&index=0&id=391bd46a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391bd46a"]])

export default __exports__